<template>
  <div>
    <div class="d-flex flex-column flex-md-row my-5 align-center">
      <div class="d-flex flex-column">
        <div class="font-weight-bold">
          Exportações
        </div>
        <div class="text-body-2 text--secondary mt-1">
          As avaliações exportadas por grupos de questões em planilhas para download<br>
          <!-- Só é possível criar uma aplicação se a avaliação estiver <strong>publicada</strong>. -->
        </div>
      </div>
      <v-spacer />
      <v-btn
        color="primary"
        text
        :disabled="!exam.is_published"
        @click="openNewExport"
      >
        <v-icon
          small
          left
        >
          mdi-plus
        </v-icon>
        Nova Exportação
      </v-btn>
      <v-btn
        color="primary"
        text
        :disabled="!exam.is_published"
        @click="openNewImport"
      >
        <v-icon
          small
          left
        >
          mdi-upload
        </v-icon>
        Importar resultados
      </v-btn>
    </div>
    <v-simple-table
      v-if="questionsView"
      fixed-header
    >
      <v-progress-linear
        v-if="loading"
        color="amber"
        indeterminate
      />
      <div
        v-else
        class="mr-5 ml-5"
      >
        <v-data-table
          :headers="headers"
          :items="applications"
          :items-per-page="10"
          item-key="id"
          no-data-text="Nenhuma aplicação cadastrada ainda"
        >
          <template #item.institution="{ item }">
            {{ item.institution.id }} - {{ item.institution.name }}
          </template>
          <template #item.updated_at="{ item }">
            {{ returnDate(item.updated_at) }}
          </template>
          <template #item.starts_at="{ item }">
            {{ returnDate(item.starts_at) }}
          </template>
          <template #item.ends_at="{ item }">
            {{ returnDate(item.ends_at) }}
          </template>
          <template #item.status="{ item }">
            {{ item.status }}
          </template>
          <template #item.created_at="{ item }">
            <div class="d-flex flex-row">
              <v-btn
                class="mx-1"
                outlined
                small
                fab
                color="primary"
                :disabled="item.download_url === null"
                @click="downloadExport(item)"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
              <v-btn
                class="mx-1"
                outlined
                small
                fab
                color="primary"
                :disabled="item.is_finished"
                @click="deleteExport(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-simple-table>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import NewExport from './NewExport.vue'
import utils from '@/api/utils.js'
import dayjs from '@/dayjs.js'
import NewImport from './NewImport.vue'
import ResultImport from './ResultImport.vue'

export default {
  components: {
  },

  mixins: [
    handlesServerValidation
  ],

  props: {
    exam: { type: Object, required: true }
  },

  data () {
    return {
      loading: false,

      applications: [],
      headers: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Descrição',
          align: 'start',
          value: 'description'
        },
        {
          text: 'Inicio',
          align: 'start',
          value: 'starts_at'
        },
        {
          text: 'Fim',
          align: 'start',
          value: 'ends_at'
        },
        {
          text: 'Data do export',
          align: 'start',
          value: 'updated_at'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'status'
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'created_at'
        }
      ]
    }
  },
  computed: {
    questionsView () {
      return utils.checkPermissions('questions.view-any')
    },
    questionsCreate () {
      return utils.checkPermissions('questions.create')
    },
    questionsUpdate () {
      return !utils.checkPermissions('grade-level-groups.update-any')
    },
    questionsDelete () {
      return !utils.checkPermissions('grade-level-groups.delete')
    }
  },
  watch: {
  },
  async mounted () {
    await this.listExamExport()
  },
  methods: {
    async listExamExport () {
      this.loading = true
      try {
        this.applications = await this.$api.listExamExport(this.exam.id)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar listar Aplicações.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },

    openNewExport () {
      this.$dialog.custom(NewExport).with({ idExam: parseInt(this.exam.id) }).show()
        .then(async (examGroupExport) => {
          if (examGroupExport) {
            await this.listExamExport()
          }
        })
    },

    openNewImport () {
      this.$dialog.custom(NewImport).with({ idExam: parseInt(this.exam.id) }).show()
        .then(async (resImport) => {
          if (resImport) {
            this.$dialog.custom(ResultImport).with({ result: resImport }).show()
          }
        })
    },

    downloadExport (item) {
      const link = document.createElement('a')

      link.href = item.download_url
      link.download = ''
      link.target = '_blank'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    async deleteExport (examExport) {
      this.$dialog.confirm('Apagar planilha de resultados?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          this.loading = true
          try {
            await this.$api.deleteExamExport(examExport.id)
            this.$store.dispatch('setSnackBar', { text: 'planilha excluído com sucesso.' })
            await this.listExamExport()
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar excluir planilha.', color: 'red' })
          } finally {
            this.loading = false
          }
        })
        .show()
    },
    returnDate (data) {
      return dayjs(data).utc(true).format('DD/MM/YYYY')
    },
    returnTime (data) {
      return dayjs(data).utc(true).format('HH:mm')
    },
    dayjs
  }
}
</script>
